const baseStyle = {
  fontSize: 'sm',
  mr: 2,
  mb: 2,
  color: '$mode.600',
  fontWeight: 'bold',
  transition: 'all 0.2s',
  opacity: 1,
  _disabled: {
    opacity: 0.4,
  },
};

export default {
  baseStyle,
};
